export default __webpack_public_path__ + "be888c9ee6fae33d58aa1bfcc24930fb.svg";